/**
 * Strips PostgREST metacharacters from a user-provided search string
 * so it can be safely interpolated into .or() filter expressions.
 *
 * Removed characters:
 *   ,  .  (  )  \  /  %  _
 *
 * These are PostgREST filter syntax or SQL LIKE wildcards.
 * Player names and usernames never contain them, so stripping is safe.
 */
export function sanitizeSearchQuery(input) {
  return input.replace(/[,.()\\%_]/g, '');
}
